import { createApiInstance } from "./api";

// Create API instances with auth interceptors
const cacheApi = createApiInstance("/cache");
const ragApi = createApiInstance("/rag");
const schedulerApi = createApiInstance("/scheduler");
const fileApi = createApiInstance("/files");

const productsApi = {
  // Clear cache
  clearCache: async () => {
    const response = await cacheApi.post("/clear");
    return response.data;
  },

  // Run product ingestion
  runIngestion: async () => {
    const response = await ragApi.post("/ingest-products");
    return response.data;
  },

  // Get scheduler status
  getSchedulerStatus: async () => {
    const response = await schedulerApi.get("/status");
    return response.data || response;
  },

  // Start product ingestion scheduler
  startScheduler: async () => {
    const response = await schedulerApi.post("/product-ingestion/start");
    return response.data;
  },

  // Stop product ingestion scheduler
  stopScheduler: async () => {
    const response = await schedulerApi.post("/product-ingestion/stop");
    return response.data;
  },

  // Get ingestion status
  getIngestionStatus: async () => {
    const response = await ragApi.get("/ingestion-status");
    return response.data || response;
  },

  // Specific cache clearing functions using cache_type parameter
  clearProductsCache: async (chatId = null) => {
    const params = { cache_type: "products" };
    if (chatId) params.chat_id = chatId;
    const response = await cacheApi.post("/invalidate", null, { params });
    return response.data;
  },

  clearGeneralInformationCache: async (chatId = null) => {
    const params = { cache_type: "general_information" };
    if (chatId) params.chat_id = chatId;
    const response = await cacheApi.post("/invalidate", null, { params });
    return response.data;
  },

  clearCampaignsCache: async (chatId = null) => {
    const params = { cache_type: "campaigns" };
    if (chatId) params.chat_id = chatId;
    const response = await cacheApi.post("/invalidate", null, { params });
    return response.data;
  },

  clearInternalProceduresCache: async (chatId = null) => {
    const params = { cache_type: "internal_procedures" };
    if (chatId) params.chat_id = chatId;
    const response = await cacheApi.post("/invalidate", null, { params });
    return response.data;
  },

  // Product Similarity Search
  searchSimilarProducts: async (query, limit = 5) => {
    const response = await ragApi.post("/products-similarity-search", {
      query,
      limit,
    });
    return response.data;
  },

  // Vector Store Statistics
  getVectorStoreStats: async () => {
    const response = await ragApi.get("/stats");
    return response.data;
  },

  clearVectorStoreCollection: async (collectionName) => {
    const response = await ragApi.post("/clear", {
      collection_name: collectionName,
    });
    return response.data;
  },

  clearAllVectorStoreCollections: async () => {
    const response = await ragApi.post("/clear");
    return response.data;
  },

  // File Management for Collections
  clearCollectionFiles: async (collectionName) => {
    const response = await fileApi.delete(
      `/collection/${collectionName}/files`
    );
    return response.data;
  },

  clearAllCollectionFiles: async () => {
    const response = await fileApi.delete("/collections/files");
    return response.data;
  },

  // Admin-only technical cache clearing functions
  clearTenantConfigCache: async (chatId = null) => {
    const params = { cache_type: "tenant_config" };
    if (chatId) params.chat_id = chatId;
    const response = await cacheApi.post("/admin/invalidate", null, { params });
    return response.data;
  },

  clearAgentCache: async (chatId = null) => {
    const params = { cache_type: "agent_meta" };
    if (chatId) params.chat_id = chatId;
    const response = await cacheApi.post("/admin/invalidate", null, { params });
    return response.data;
  },

  clearChatHistoryCache: async (chatId = null) => {
    const params = { cache_type: "chat_history" };
    if (chatId) params.chat_id = chatId;
    const response = await cacheApi.post("/admin/invalidate", null, { params });
    return response.data;
  },

  clearIngestionStatusCache: async (chatId = null) => {
    const params = { cache_type: "ingestion_status" };
    if (chatId) params.chat_id = chatId;
    const response = await cacheApi.post("/admin/invalidate", null, { params });
    return response.data;
  },

  clearWorkflowCache: async (chatId = null) => {
    const params = { cache_type: "workflow" };
    if (chatId) params.chat_id = chatId;
    const response = await cacheApi.post("/admin/invalidate", null, { params });
    return response.data;
  },

  clearAllTechnicalCache: async (chatId = null) => {
    const params = { cache_type: "all_technical" };
    if (chatId) params.chat_id = chatId;
    const response = await cacheApi.post("/admin/invalidate", null, { params });
    return response.data;
  },
};

export { productsApi };
